import { FormField } from 'src/common/FormField';
import { FormContextField } from 'src/common/FormField/FormContextField';

export default function LocationSettings() {
  return (
    <div className="grid grid-cols-1 gap-x-4 gap-y-4 border-b border-gray-900/10 py-5 md:grid-cols-4">
      <div>
        <h2 className="text-base font-semibold leading-7 text-gray-900">
          Export Settings
        </h2>
        <p className="mt-1 text-sm leading-6 text-gray-600">
          Organization defaults for exporting data.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 md:col-span-3">
        <div>
          <FormContextField name="tax_id">
            {({ field }) => {
              return (
                <>
                  <FormField
                    label="Tax ID"
                    type="text"
                    inputProps={{
                      id: 'tax_id',
                      placeholder: 'Tax ID for export',
                      ...field,
                    }}
                  />
                </>
              );
            }}
          </FormContextField>
        </div>
      </div>
    </div>
  );
}
